import React, { useEffect, useState } from 'react';
import { Box, Skeleton } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { usePostContext } from '../PostContext';
import PostNavigation from './PostNavigation';
import PostShare from './PostShare';

const DynamicBlockContent = dynamic(
  () => import('@components/Shared/BlockContent')
);

const DynamicSanityImage = dynamic(
  () => import('@components/Shared/SanityImage')
);

const DynamicPostTitle = dynamic(() => import('../PostTitle/PostTitle'));

const PostContent: React.FC = () => {
  const { post } = usePostContext();
  const { asPath } = useRouter();
  const [showImage, setShowImage] = useState(false);
  const imageUrl = post?.mainPhoto?.asset?.url;

  useEffect(() => {
    setShowImage(false);
    setTimeout(() => {
      setShowImage(true);
    }, 300);
  }, [asPath]);

  return (
    <Box w={['100%', null, '66%']} px={{ lg: '20px' }}>
      <Box mt={6}>
        <Skeleton isLoaded={showImage}>
          {imageUrl && (
            <Box mb="20px">
              <DynamicSanityImage
                sanityImage={post.mainPhoto}
                layout="responsive"
                width={650}
                height={350}
              />
            </Box>
          )}
        </Skeleton>

        <DynamicPostTitle />

        <DynamicBlockContent content={post?.postContentRaw} />
      </Box>
      <PostShare />
      <PostNavigation />
    </Box>
  );
};

export default PostContent;
